import { takeEvery } from 'redux-saga/effects';
import requestInitialDataSaga from './requestInitialData';
import {
    REQUEST_INITIAL_DATA,
} from '../actions';

export default function* campaignCalendarSaga() {
    yield takeEvery(REQUEST_INITIAL_DATA, requestInitialDataSaga);
}
